import type { ResolveFn } from '../types.js';

export const resolveField: ResolveFn = (b, roll, _state, rules) => {
  const t = roll.total;
  if (t === 2) {
    return { betId: b.id, outcome: 'win', payout: b.amount * rules.fieldDeucePayout };
  }
  if (t === 12) {
    return { betId: b.id, outcome: 'win', payout: b.amount * rules.field12Payout };
  }
  if (t === 3 || t === 4 || t === 9 || t === 10 || t === 11) {
    return { betId: b.id, outcome: 'win', payout: b.amount };
  }
  return { betId: b.id, outcome: 'lose', payout: 0 };
};
